// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-cf5e55fe] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.profile-hover-card[data-v-cf5e55fe] {
  box-sizing: border-box;
  position: relative;
  width: 560px;
  max-width: min(560px, 90vw);
  min-height: 300px;
  overflow: hidden;
  color: var(--color-main-text);
  background-color: var(--color-main-background);
  border-radius: var(--border-radius-large);
  display: flex;
  flex-direction: column;
}
.profile-hover-card__header[data-v-cf5e55fe] {
  display: flex;
  flex-shrink: 0;
  position: relative;
  height: 127px;
  background-color: var(--color-primary-element-light);
}
.profile-hover-card__header__edit[data-v-cf5e55fe] {
  position: absolute;
  inset-block-start: 8px;
  inset-inline-end: 8px;
  z-index: 1;
}
.profile-hover-card__header__container[data-v-cf5e55fe] {
  align-self: flex-end;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  width: 100%;
  margin: 8px 0;
  padding-inline: 16px;
  box-sizing: border-box;
}
.profile-hover-card__header__container__placeholder[data-v-cf5e55fe] {
  flex: 0 0 180px;
  width: 180px;
}
.profile-hover-card__header__container__avatar[data-v-cf5e55fe] {
  flex-shrink: 0;
}
.profile-hover-card__header__container__identity[data-v-cf5e55fe] {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  flex: 1;
  padding-inline: 0;
}
.profile-hover-card__header__container__displayname[data-v-cf5e55fe] {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
.profile-hover-card__header__container__displayname h2[data-v-cf5e55fe] {
  font-size: 24px;
  margin: 0;
  overflow-wrap: anywhere;
}
.profile-hover-card__header__container__pronouns[data-v-cf5e55fe] {
  font-size: 15px;
  color: var(--color-text-maxcontrast);
}
.profile-hover-card__header__container__status[data-v-cf5e55fe] {
  min-width: 0;
}
.profile-hover-card__header__container__status-content[data-v-cf5e55fe] {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  overflow-wrap: anywhere;
}
.profile-hover-card__body[data-v-cf5e55fe] {
  flex: 1;
  min-height: 0;
  background-color: var(--color-main-background);
}
.profile-hover-card__content[data-v-cf5e55fe] {
  display: flex;
  width: 100%;
  height: 100%;
  padding-inline: 16px 16px;
  box-sizing: border-box;
}
.profile-hover-card__sidebar[data-v-cf5e55fe] {
  align-self: flex-start;
  padding-top: 8px;
  width: 180px;
  min-width: 180px;
  margin-block: -100px 0;
  margin-inline: 0 12px;
}
.profile-hover-card__header[data-v-cf5e55fe] .avatar.avatardiv, .profile-hover-card__sidebar[data-v-cf5e55fe] .avatar.avatardiv {
  text-align: center;
  margin: auto;
  display: block;
  padding: 8px;
}
.profile-hover-card__header[data-v-cf5e55fe] .avatar.avatardiv .avatardiv__user-status, .profile-hover-card__sidebar[data-v-cf5e55fe] .avatar.avatardiv .avatardiv__user-status {
  inset-inline-end: 10px;
  bottom: 10px;
  width: 26px;
  height: 26px;
  background-size: 22px;
  border: none;
  background-color: var(--color-main-background);
  line-height: 26px;
  font-size: 16px;
}
.profile-hover-card__blocks[data-v-cf5e55fe] {
  margin: 12px 0 12px 0;
  display: grid;
  gap: 8px 0;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  align-content: start;
}
.profile-hover-card__blocks p[data-v-cf5e55fe], .profile-hover-card__blocks h3[data-v-cf5e55fe] {
  overflow-wrap: anywhere;
}
.profile-hover-card__blocks-details[data-v-cf5e55fe] {
  display: flex;
  flex-direction: column;
  gap: 2px 0;
}
.profile-hover-card__blocks-details .detail[data-v-cf5e55fe] {
  display: inline-block;
  color: var(--color-text-maxcontrast);
  font-size: 14px;
}
.profile-hover-card__blocks-details .detail p .detail-icon[data-v-cf5e55fe] {
  display: inline-block;
  vertical-align: middle;
}
.profile-hover-card__blocks-headline[data-v-cf5e55fe] {
  margin-inline: 0;
  margin-block: 4px 0;
  font-weight: bold;
  font-size: 16px;
}
.profile-hover-card__blocks-biography[data-v-cf5e55fe] {
  overflow: hidden;
  font-size: 14px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
}
.profile-hover-card__blocks-biography[data-v-cf5e55fe] p {
  margin: 0;
}
.profile-hover-card__blocks-empty-info[data-v-cf5e55fe] {
  margin: 0;
  padding: 0;
}
.profile-hover-card__loading[data-v-cf5e55fe], .profile-hover-card__error[data-v-cf5e55fe] {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 300px;
  padding: 16px;
  color: var(--color-text-maxcontrast);
}
.user-actions[data-v-cf5e55fe] {
  display: flex;
  flex-direction: column;
  gap: 8px 0;
  margin-top: 12px;
  max-width: 180px;
}
.user-actions__loading[data-v-cf5e55fe] {
  display: flex;
  justify-content: center;
  padding: 8px 0;
}
.user-actions__primary[data-v-cf5e55fe] {
  margin: 0 auto;
  width: 180px !important;
}
.user-actions__primary__icon[data-v-cf5e55fe] {
  height: 20px;
  width: 20px;
  object-fit: contain;
  filter: var(--primary-invert-if-dark);
}
.user-actions__primary__icon-class[data-v-cf5e55fe] {
  display: block;
  height: 20px;
  width: 20px;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
  filter: var(--primary-invert-if-dark);
}
.user-actions__other[data-v-cf5e55fe] {
  display: flex;
  justify-content: center;
  gap: 0 4px;
}
.user-actions__other__icon[data-v-cf5e55fe] {
  height: 20px;
  width: 20px;
  object-fit: contain;
  filter: var(--background-invert-if-dark);
  align-self: center;
  margin: 8px;
}
.user-actions__other__icon-class[data-v-cf5e55fe] {
  display: block;
  height: 20px;
  width: 20px;
  margin: 8px;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
  filter: var(--background-invert-if-dark);
}
@media only screen and (max-width: 512px) {
.profile-hover-card[data-v-cf5e55fe] {
    width: min(560px, 100vw - 24px);
    max-width: calc(100vw - 24px);
    height: auto;
    min-height: 0;
    max-height: min(80vh, 520px);
    overflow: auto;
}
.profile-hover-card__header[data-v-cf5e55fe] {
    height: auto;
    min-height: 112px;
}
.profile-hover-card__header__container[data-v-cf5e55fe] {
    align-self: flex-end;
    align-items: flex-end;
    gap: 16px;
    margin: 12px auto;
    padding-inline: 12px;
}
.profile-hover-card__header__container__avatar[data-v-cf5e55fe] {
    align-self: flex-end;
}
.profile-hover-card__header__container__identity[data-v-cf5e55fe] {
    gap: 6px;
    padding-inline: 0;
    justify-content: flex-end;
}
.profile-hover-card__header__container__displayname[data-v-cf5e55fe] {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}
.profile-hover-card__header__container__displayname h2[data-v-cf5e55fe] {
    font-size: 20px;
}
.profile-hover-card__header__container__pronouns[data-v-cf5e55fe] {
    font-size: 16px;
}
.profile-hover-card__header__container__pronoun-separator[data-v-cf5e55fe] {
    display: none;
}
.profile-hover-card__header__container__status-content[data-v-cf5e55fe] {
    font-size: 16px;
}
.profile-hover-card__content[data-v-cf5e55fe] {
    display: block;
    height: auto;
    padding-inline: 12px;
    padding-block-end: 12px;
}
.profile-hover-card__sidebar[data-v-cf5e55fe] {
    margin: unset;
    width: auto;
    min-width: 0;
    padding-top: 0;
}
.profile-hover-card__blocks[data-v-cf5e55fe] {
    width: unset;
    margin: 0;
    padding: 8px 4px 12px;
}
.profile-hover-card__header[data-v-cf5e55fe] .avatar.avatardiv .avatardiv__user-status, .profile-hover-card__sidebar[data-v-cf5e55fe] .avatar.avatardiv .avatardiv__user-status {
    inset-inline-end: 0;
    bottom: 0;
}
.profile-hover-card__loading[data-v-cf5e55fe], .profile-hover-card__error[data-v-cf5e55fe] {
    min-height: 200px;
}
.user-actions[data-v-cf5e55fe] {
    width: unset;
    max-width: none;
    margin: 8px auto 0;
    padding: 0 4px;
}
.user-actions__primary[data-v-cf5e55fe] {
    width: 100% !important;
    max-width: 220px;
}
.user-actions__other[data-v-cf5e55fe] {
    flex-wrap: wrap;
}
}
@media only screen and (max-width: 480px) {
.profile-hover-card[data-v-cf5e55fe] {
    width: calc(100vw - 16px);
    max-width: calc(100vw - 16px);
    border-radius: var(--border-radius);
}
.profile-hover-card__header__container[data-v-cf5e55fe] {
    gap: 8px;
    padding-inline: 8px;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcProfileHoverCard-D3V682nS.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,8CAA8C;EAC9C,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,8CAA8C;EAC9C,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;AACA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,YAAY;IACZ,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;AACA;AACA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;AACvC;AACA;IACI,QAAQ;IACR,mBAAmB;AACvB;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-cf5e55fe] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.profile-hover-card[data-v-cf5e55fe] {\n  box-sizing: border-box;\n  position: relative;\n  width: 560px;\n  max-width: min(560px, 90vw);\n  min-height: 300px;\n  overflow: hidden;\n  color: var(--color-main-text);\n  background-color: var(--color-main-background);\n  border-radius: var(--border-radius-large);\n  display: flex;\n  flex-direction: column;\n}\n.profile-hover-card__header[data-v-cf5e55fe] {\n  display: flex;\n  flex-shrink: 0;\n  position: relative;\n  height: 127px;\n  background-color: var(--color-primary-element-light);\n}\n.profile-hover-card__header__edit[data-v-cf5e55fe] {\n  position: absolute;\n  inset-block-start: 8px;\n  inset-inline-end: 8px;\n  z-index: 1;\n}\n.profile-hover-card__header__container[data-v-cf5e55fe] {\n  align-self: flex-end;\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  width: 100%;\n  margin: 8px 0;\n  padding-inline: 16px;\n  box-sizing: border-box;\n}\n.profile-hover-card__header__container__placeholder[data-v-cf5e55fe] {\n  flex: 0 0 180px;\n  width: 180px;\n}\n.profile-hover-card__header__container__avatar[data-v-cf5e55fe] {\n  flex-shrink: 0;\n}\n.profile-hover-card__header__container__identity[data-v-cf5e55fe] {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n  padding-inline: 0;\n}\n.profile-hover-card__header__container__displayname[data-v-cf5e55fe] {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n}\n.profile-hover-card__header__container__displayname h2[data-v-cf5e55fe] {\n  font-size: 24px;\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n.profile-hover-card__header__container__pronouns[data-v-cf5e55fe] {\n  font-size: 15px;\n  color: var(--color-text-maxcontrast);\n}\n.profile-hover-card__header__container__status[data-v-cf5e55fe] {\n  min-width: 0;\n}\n.profile-hover-card__header__container__status-content[data-v-cf5e55fe] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  overflow-wrap: anywhere;\n}\n.profile-hover-card__body[data-v-cf5e55fe] {\n  flex: 1;\n  min-height: 0;\n  background-color: var(--color-main-background);\n}\n.profile-hover-card__content[data-v-cf5e55fe] {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding-inline: 16px 16px;\n  box-sizing: border-box;\n}\n.profile-hover-card__sidebar[data-v-cf5e55fe] {\n  align-self: flex-start;\n  padding-top: 8px;\n  width: 180px;\n  min-width: 180px;\n  margin-block: -100px 0;\n  margin-inline: 0 12px;\n}\n.profile-hover-card__header[data-v-cf5e55fe] .avatar.avatardiv, .profile-hover-card__sidebar[data-v-cf5e55fe] .avatar.avatardiv {\n  text-align: center;\n  margin: auto;\n  display: block;\n  padding: 8px;\n}\n.profile-hover-card__header[data-v-cf5e55fe] .avatar.avatardiv .avatardiv__user-status, .profile-hover-card__sidebar[data-v-cf5e55fe] .avatar.avatardiv .avatardiv__user-status {\n  inset-inline-end: 10px;\n  bottom: 10px;\n  width: 26px;\n  height: 26px;\n  background-size: 22px;\n  border: none;\n  background-color: var(--color-main-background);\n  line-height: 26px;\n  font-size: 16px;\n}\n.profile-hover-card__blocks[data-v-cf5e55fe] {\n  margin: 12px 0 12px 0;\n  display: grid;\n  gap: 8px 0;\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  align-content: start;\n}\n.profile-hover-card__blocks p[data-v-cf5e55fe], .profile-hover-card__blocks h3[data-v-cf5e55fe] {\n  overflow-wrap: anywhere;\n}\n.profile-hover-card__blocks-details[data-v-cf5e55fe] {\n  display: flex;\n  flex-direction: column;\n  gap: 2px 0;\n}\n.profile-hover-card__blocks-details .detail[data-v-cf5e55fe] {\n  display: inline-block;\n  color: var(--color-text-maxcontrast);\n  font-size: 14px;\n}\n.profile-hover-card__blocks-details .detail p .detail-icon[data-v-cf5e55fe] {\n  display: inline-block;\n  vertical-align: middle;\n}\n.profile-hover-card__blocks-headline[data-v-cf5e55fe] {\n  margin-inline: 0;\n  margin-block: 4px 0;\n  font-weight: bold;\n  font-size: 16px;\n}\n.profile-hover-card__blocks-biography[data-v-cf5e55fe] {\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 4;\n  line-clamp: 4;\n  text-overflow: ellipsis;\n  overflow-wrap: anywhere;\n}\n.profile-hover-card__blocks-biography[data-v-cf5e55fe] p {\n  margin: 0;\n}\n.profile-hover-card__blocks-empty-info[data-v-cf5e55fe] {\n  margin: 0;\n  padding: 0;\n}\n.profile-hover-card__loading[data-v-cf5e55fe], .profile-hover-card__error[data-v-cf5e55fe] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 300px;\n  padding: 16px;\n  color: var(--color-text-maxcontrast);\n}\n.user-actions[data-v-cf5e55fe] {\n  display: flex;\n  flex-direction: column;\n  gap: 8px 0;\n  margin-top: 12px;\n  max-width: 180px;\n}\n.user-actions__loading[data-v-cf5e55fe] {\n  display: flex;\n  justify-content: center;\n  padding: 8px 0;\n}\n.user-actions__primary[data-v-cf5e55fe] {\n  margin: 0 auto;\n  width: 180px !important;\n}\n.user-actions__primary__icon[data-v-cf5e55fe] {\n  height: 20px;\n  width: 20px;\n  object-fit: contain;\n  filter: var(--primary-invert-if-dark);\n}\n.user-actions__primary__icon-class[data-v-cf5e55fe] {\n  display: block;\n  height: 20px;\n  width: 20px;\n  background-size: 20px;\n  background-repeat: no-repeat;\n  background-position: center;\n  filter: var(--primary-invert-if-dark);\n}\n.user-actions__other[data-v-cf5e55fe] {\n  display: flex;\n  justify-content: center;\n  gap: 0 4px;\n}\n.user-actions__other__icon[data-v-cf5e55fe] {\n  height: 20px;\n  width: 20px;\n  object-fit: contain;\n  filter: var(--background-invert-if-dark);\n  align-self: center;\n  margin: 8px;\n}\n.user-actions__other__icon-class[data-v-cf5e55fe] {\n  display: block;\n  height: 20px;\n  width: 20px;\n  margin: 8px;\n  background-size: 20px;\n  background-repeat: no-repeat;\n  background-position: center;\n  filter: var(--background-invert-if-dark);\n}\n@media only screen and (max-width: 512px) {\n.profile-hover-card[data-v-cf5e55fe] {\n    width: min(560px, 100vw - 24px);\n    max-width: calc(100vw - 24px);\n    height: auto;\n    min-height: 0;\n    max-height: min(80vh, 520px);\n    overflow: auto;\n}\n.profile-hover-card__header[data-v-cf5e55fe] {\n    height: auto;\n    min-height: 112px;\n}\n.profile-hover-card__header__container[data-v-cf5e55fe] {\n    align-self: flex-end;\n    align-items: flex-end;\n    gap: 16px;\n    margin: 12px auto;\n    padding-inline: 12px;\n}\n.profile-hover-card__header__container__avatar[data-v-cf5e55fe] {\n    align-self: flex-end;\n}\n.profile-hover-card__header__container__identity[data-v-cf5e55fe] {\n    gap: 6px;\n    padding-inline: 0;\n    justify-content: flex-end;\n}\n.profile-hover-card__header__container__displayname[data-v-cf5e55fe] {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n}\n.profile-hover-card__header__container__displayname h2[data-v-cf5e55fe] {\n    font-size: 20px;\n}\n.profile-hover-card__header__container__pronouns[data-v-cf5e55fe] {\n    font-size: 16px;\n}\n.profile-hover-card__header__container__pronoun-separator[data-v-cf5e55fe] {\n    display: none;\n}\n.profile-hover-card__header__container__status-content[data-v-cf5e55fe] {\n    font-size: 16px;\n}\n.profile-hover-card__content[data-v-cf5e55fe] {\n    display: block;\n    height: auto;\n    padding-inline: 12px;\n    padding-block-end: 12px;\n}\n.profile-hover-card__sidebar[data-v-cf5e55fe] {\n    margin: unset;\n    width: auto;\n    min-width: 0;\n    padding-top: 0;\n}\n.profile-hover-card__blocks[data-v-cf5e55fe] {\n    width: unset;\n    margin: 0;\n    padding: 8px 4px 12px;\n}\n.profile-hover-card__header[data-v-cf5e55fe] .avatar.avatardiv .avatardiv__user-status, .profile-hover-card__sidebar[data-v-cf5e55fe] .avatar.avatardiv .avatardiv__user-status {\n    inset-inline-end: 0;\n    bottom: 0;\n}\n.profile-hover-card__loading[data-v-cf5e55fe], .profile-hover-card__error[data-v-cf5e55fe] {\n    min-height: 200px;\n}\n.user-actions[data-v-cf5e55fe] {\n    width: unset;\n    max-width: none;\n    margin: 8px auto 0;\n    padding: 0 4px;\n}\n.user-actions__primary[data-v-cf5e55fe] {\n    width: 100% !important;\n    max-width: 220px;\n}\n.user-actions__other[data-v-cf5e55fe] {\n    flex-wrap: wrap;\n}\n}\n@media only screen and (max-width: 480px) {\n.profile-hover-card[data-v-cf5e55fe] {\n    width: calc(100vw - 16px);\n    max-width: calc(100vw - 16px);\n    border-radius: var(--border-radius);\n}\n.profile-hover-card__header__container[data-v-cf5e55fe] {\n    gap: 8px;\n    padding-inline: 8px;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
